import "core-js/modules/web.dom.iterable";
// 过滤出后台返回状态值对应的中文意思
export function filtered(options, currVal) {
  var currLable = null;
  options && options.forEach(function (item) {
    if (item.value === currVal) {
      currLable = item.label;
    }
  });
  return currLable;
}
// parentDefaultVal 父级最高级默认Id是多少
// childrenId 当前选择的最后一级
// ProductLineList 总数据
// keyField 当前对象的id代码名称 默认等于Id
// parentField 当前对象的parentId名称 默认等于ParentId
export function getParentId(childrenId, ProductLineList) {
  var keyField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var parentField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "parentId";
  var parentDefaultVal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var dataArr = [];
  dataArr.push(childrenId);
  function oper() {
    for (var i = 0; i < ProductLineList.length; i++) {
      var parents = ProductLineList[i];
      if (parents[keyField] === childrenId) {
        if (dataArr.indexOf(1) !== -1) {
          break;
        } else {
          if (parents[parentField] !== parentDefaultVal) {
            dataArr.unshift(parents[parentField]);
            childrenId = parents[parentField];
            if (childrenId !== parentDefaultVal) {
              oper(childrenId);
            }
          }
        }
      }
    }
  }
  oper();
  return dataArr;
}
// parentId 父级最高级默认Id是多少
// childrenField 当前children的字段名
// list 总数据
// keyField 当前对象的id代码名称 默认等于Id
// parentField 当前对象的parentId名称 默认等于parentId
export function listToTree(list, parentId) {
  var keyField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var parentField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "parentId";
  var childrenField = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "children";
  var children = [];
  list.forEach(function (item) {
    if (!parentId) {
      if (!item[parentField]) {
        children.push(item);
        if (item[keyField]) {
          item[childrenField] = listToTree(list, item[keyField], keyField, parentField, childrenField);
        }
      }
    } else if (item[parentField] === parentId) {
      children.push(item);
      if (item[keyField]) {
        item[childrenField] = listToTree(list, item[keyField], keyField, parentField, childrenField);
      }
    }
  });
  return children.length === 0 ? null : children;
}

/**
 * 计算页面高度
 * @param {*string} type 页签类型
 * @param {*string} activeName 待办或已办
 * @param {*number} totalCount table页数
 */
export function getTableHeight(moduleType, type, activeName, totalCount) {
  // 页面总视图高度
  var boxH = document.body.clientHeight;
  // 查询
  var advancedSearch = document.getElementsByClassName('search-filter-wrap')[0] ? document.getElementsByClassName('search-filter-wrap')[0].clientHeight : 0;
  // 横向页签切换
  var searchTabH = document.getElementsByClassName('search-tab')[0] ? document.getElementsByClassName('search-tab')[0].clientHeight : 0;
  var paginationH = totalCount === 0 ? 0 : 50;
  var height;
  // type代表页面不同的结构
  if (type === 1) {
    if (activeName === "pending") {
      height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
    } else {
      height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
    }
  } else if (type === 2) {
    height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  } else if (type === 3) {
    height = boxH - 64 - 36 - 20 - searchTabH - advancedSearch - 48 - 20 - paginationH - 8;
  }
  if (height < 400) {
    height = 400;
  }
  // // 64页面顶部导航， 36二级导航， 20主内容内边距， 高级查询默认117（advancedSearch）, 20/48查询和tanble间隔, 20table内边距, 50分页paginationH
  // if (moduleType === "playBoard") { // 版单设计
  //   switch (type) {
  //     case "PlayBoardAll": // 全部
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       break;
  //     case "StaySingle": // 待分单
  //       if (activeName === "pending") {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       } else {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       }
  //       break;
  //     case "StayCreate": // 待创建
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       break;
  //     case "StayBomCreate": // 待BOM单创建
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       break;
  //     case "Complete": // 已完成
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       break;
  //   }
  // } else if (moduleType === "flowerDraft") { // 花稿设计
  //   switch (type) {
  //     case "FlowerDesignAll": // 全部
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       break;
  //     case "FlowerDesignStayApply": // 待花稿设计申请
  //       if (activeName === "pending") {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       } else {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       }
  //       break;
  //     case "FlowerDesignStayAllocate": // 待设计分配
  //       if (activeName === "pending") {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       } else {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       }
  //       break;
  //     case "FlowerDesignStayCompany": // 花稿自设计
  //       if (activeName === "pending") {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       } else {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       }
  //       break;
  //     case "FlowerDesignStayOutside": // 花稿加工厂设计
  //       if (activeName === "pending") {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       } else {
  //         height = boxH - 64 - 36 - 20 - advancedSearch - 20 - 20 - paginationH - 8;
  //       }
  //       break;
  //     case "FlowerDesignFlowerDisgnerStayConfirm": // 待花稿师确认
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       break;
  //     case "FlowerDesignDisgnerStayConfirm": // 待设计师确认
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 48 - 20 - paginationH - 8;
  //       break;
  //     case "FlowerDesignCompleted": // 已完成
  //       height = boxH - 64 - 36 - 20 - advancedSearch - 28 - 20 - paginationH - 8;
  //       break;
  //   }
  // }
  return height;
}